import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AppSearch} from "../../models/appSearch.model";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {
    QuestionModalComponent
} from "../../../app/components/footer/components/question-modal/question-modal.component";

@Component(
        {
            templateUrl: './app-search.component.html',
            styleUrls: ['./app-search.component.scss']
        }
)
export class AppSearchComponent implements OnInit {
    public appSearch: AppSearch;

    constructor(
            private route: ActivatedRoute,
            private router: Router,
            private modalService: NgbModal
    ) {
    }

    public ngOnInit() {
        this.route.data.subscribe(data => {
            this.appSearch = data.appSearchResult;
        });
    }

    public get hierarchyFacets() {
        return this.appSearch.facets.filter(
                facetTypes => facetTypes.filter(
                        facet => [
                                    'product_hierarchy_level_1',
                                    'product_hierarchy_level_2',
                                    'product_hierarchy_level_3',
                                    'product_hierarchy_level_4',
                                    'product_hierarchy_level_5'
                                ].includes(facet.cid)
                                && facet.options.length > 0
                ).length
        );
    }

    public get generalFacets() {
        return this.appSearch.facets.filter(
                facetTypes => facetTypes.filter(
                        facet => ![
                                    'product_hierarchy_level_1',
                                    'product_hierarchy_level_2',
                                    'product_hierarchy_level_3',
                                    'product_hierarchy_level_4',
                                    'product_hierarchy_level_5'
                                ].includes(facet.cid)
                                && facet.options.length > 1
                ).length
        );
    }

    public get urlSearchParams(): URLSearchParams {
        let urlSearchParams = new URLSearchParams();

        if (this.appSearch.query) {
            urlSearchParams.append('query', this.appSearch.query);
        }

        for (let facets of this.appSearch.facets) {
            for (let facet of facets) {
                for (let option of facet.options) {
                    if (option.checked) {
                        urlSearchParams.append('filters[' + facet.cid + '][]', option.value);
                    }
                }
            }
        }

        if (this.appSearch.meta.page.current > 1) {
            urlSearchParams.append('page', this.appSearch.meta.page.current.toString());
        }

        return urlSearchParams;
    }

    public toggleFacetOption() {
        this.appSearch.meta.page.current = 1;

        this.submit();
    }

    public search() {
        this.router.navigate(
                [
                    '/catalogue',
                    'search'
                ],
                {
                    queryParams: {
                        query: this.appSearch.query
                    }
                }
        ).then();
    }

    public submitQuery(query: string) {
        this.router.navigate(['/catalogue', 'search'], {queryParams: {query: query}}).then();
    }

    public submit() {
        this.router.navigateByUrl('/catalogue/search?' + this.urlSearchParams.toString()).then();
    }

    public openQuestionModal() {
        const modalRef = this.modalService.open(QuestionModalComponent, {size: 'lg', backdrop: 'static'});
    }
}
